import { useContext, useSyncExternalStore } from "react";
import { EmptySnapshot } from "@snort/system";
import { unwrap } from "@snort/shared";
import { SnortContext } from "./context";
/**
 * Send a query to the relays and wait for data
 */
const useRequestBuilder = (type, rb) => {
    const system = useContext(SnortContext);
    const subscribe = (onChanged) => {
        if (rb) {
            const q = system.Query(type, rb);
            const release = q.feed.hook(onChanged);
            q.uncancel();
            return () => {
                q.cancel();
                release();
            };
        }
        return () => {
            // noop
        };
    };
    const getState = () => {
        const q = system.GetQuery(rb?.id ?? "");
        if (q) {
            return unwrap(q).feed?.snapshot;
        }
        return EmptySnapshot;
    };
    return useSyncExternalStore(v => subscribe(v), () => getState());
};
export { useRequestBuilder };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlUmVxdWVzdEJ1aWxkZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvdXNlUmVxdWVzdEJ1aWxkZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxVQUFVLEVBQUUsb0JBQW9CLEVBQUUsTUFBTSxPQUFPLENBQUM7QUFDekQsT0FBTyxFQUFrQixhQUFhLEVBQTRCLE1BQU0sZUFBZSxDQUFDO0FBQ3hGLE9BQU8sRUFBRSxNQUFNLEVBQUUsTUFBTSxlQUFlLENBQUM7QUFDdkMsT0FBTyxFQUFFLFlBQVksRUFBRSxNQUFNLFdBQVcsQ0FBQztBQUV6Qzs7R0FFRztBQUNILE1BQU0saUJBQWlCLEdBQUcsQ0FDeEIsSUFBd0IsRUFDeEIsRUFBeUIsRUFDekIsRUFBRTtJQUNGLE1BQU0sTUFBTSxHQUFHLFVBQVUsQ0FBQyxZQUFZLENBQUMsQ0FBQztJQUN4QyxNQUFNLFNBQVMsR0FBRyxDQUFDLFNBQXFCLEVBQUUsRUFBRTtRQUMxQyxJQUFJLEVBQUUsRUFBRTtZQUNOLE1BQU0sQ0FBQyxHQUFHLE1BQU0sQ0FBQyxLQUFLLENBQVMsSUFBSSxFQUFFLEVBQUUsQ0FBQyxDQUFDO1lBQ3pDLE1BQU0sT0FBTyxHQUFHLENBQUMsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxDQUFDO1lBQ3ZDLENBQUMsQ0FBQyxRQUFRLEVBQUUsQ0FBQztZQUNiLE9BQU8sR0FBRyxFQUFFO2dCQUNWLENBQUMsQ0FBQyxNQUFNLEVBQUUsQ0FBQztnQkFDWCxPQUFPLEVBQUUsQ0FBQztZQUNaLENBQUMsQ0FBQztTQUNIO1FBQ0QsT0FBTyxHQUFHLEVBQUU7WUFDVixPQUFPO1FBQ1QsQ0FBQyxDQUFDO0lBQ0osQ0FBQyxDQUFDO0lBQ0YsTUFBTSxRQUFRLEdBQUcsR0FBNkIsRUFBRTtRQUM5QyxNQUFNLENBQUMsR0FBRyxNQUFNLENBQUMsUUFBUSxDQUFDLEVBQUUsRUFBRSxFQUFFLElBQUksRUFBRSxDQUFDLENBQUM7UUFDeEMsSUFBSSxDQUFDLEVBQUU7WUFDTCxPQUFPLE1BQU0sQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLEVBQUUsUUFBb0MsQ0FBQztTQUM3RDtRQUNELE9BQU8sYUFBeUMsQ0FBQztJQUNuRCxDQUFDLENBQUM7SUFDRixPQUFPLG9CQUFvQixDQUN6QixDQUFDLENBQUMsRUFBRSxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsRUFDakIsR0FBRyxFQUFFLENBQUMsUUFBUSxFQUFFLENBQ2pCLENBQUM7QUFDSixDQUFDLENBQUM7QUFFRixPQUFPLEVBQUUsaUJBQWlCLEVBQUUsQ0FBQyJ9